
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';
import { DataLoadService } from 'src/app/shared/services/data-load.service';

@Component({
  selector: 'app-sales-contract-list',
  templateUrl: './../../../templates/forms/modals/sales-contact-list.component.html',
})
export class SalesContractListComponent implements OnInit {
  @Input()
  modalShow: boolean = true;

  @Input()
  startDate;

  @Input()
  endDate;

  @Input()
  customerNo;

  @Input()
  optionalParam;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj: any;

  salesContractList = [];

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "SalesContractListGrid";

  searchFields: any[] = ['DOC_AMENDMENT'];
  public searchString;
  constructor(private dataService: CommonService,
    public dataLoadService: DataLoadService,
    public langService: LangService,
    public gridService: GridService) {
    this.colObj = [
      { headerName: langService.langData.documentQlonAmendment, field: 'DOC_AMENDMENT', sortable: true, filter: true, resizable: true, hide: false },
      { headerName: langService.langData.openingDate, field: 'OPENING_DATE', sortable: true, filter: true, resizable: true, hide: false },
    ];
  }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }

  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    if (this.optionalParam) {
      this.dataLoadService.load('FG_SL_COMM_CONTACT_BY_CUSTOMER', this.optionalParam).subscribe(arg => {
        this.salesContractList = arg.body
      })
    } else {
      this.dataService.getContactsDocByCustomer(this.startDate, this.endDate, this.customerNo)
        .subscribe(arg => { this.salesContractList = arg.body });
    }
  }

  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next(_item);
  }
}


